import React, { useEffect, useState } from "react";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchCareerData } from "../../redux/website-reducers/websiteSlice";
import { selectAuth } from "../../components/auth/auth.selector";
import "./../../styles/website/career.css";
import Loader from "../../components/ui/Loader";
import Modal from "react-modal";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { deleteCareer } from "../../data/ApiEndpoints";
import HelmetWrapper from "../../HelmetWrapper";
import CareerForm from "../../components/website-contents/career/careerForm";
import { Col, Container, Row } from "react-bootstrap";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import {
  DeleteIcon,
  EditIcon,
  SearchIcon,
} from "../../images/icons/website-icons";
import SelectDropdownLabel from "../../components/components-react/SelectDropdownLabel";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import DateRanger from "../../components/components-react/DateRanger";
// import { Calendar, DateRangePicker } from "react-date-range";
import { addDays, format } from "date-fns";
import moment from "moment";
import {
  CalenderIcon,
  ClearCalenderIcon,
  ClearIcon,
  CloseIcon,
} from "../../images/icons/icons";

const Career = () => {
  const dispatch = useDispatch();
  const { loading, careerData } = useSelector((state) => state.webApi);
  const [modValues, setModValues] = useState("");
  const [descModalOpen, setDescModalOpen] = useState(false);

  const [isPage, setIsPage] = useState(0);

  const [searchValue, setSearchValue] = useState("");

  const initalFilter = {
    search: "",
    status: "",
    limit: 10,
    page: isPage + 1,
    start_date: "",
    end_date: "",
  };

  const [filters, setFilters] = useState(initalFilter);

  // console.log("filters==>", filters);

  const [isEdit, setIsEdit] = useState(false);

  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const [modalOpen, setModalOpen] = useState(false);
  const [initialValue, setInitialValue] = useState(null);

  const [openDateRanger, setOpenDateRanger] = useState(false);

  const initialRangeState = [
    {
      start_date: new Date(),
      end_date: addDays(new Date(), 7),
      key: "selection",
    },
  ];

  const [rangeState, setRangeState] = useState(initialRangeState);

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(
      item?.selection?.start_date,
      "yyyy-MM-dd"
    );
    const formattedEndDate = format(item?.selection?.end_date, "yyyy-MM-dd");

    setFilters({
      ...filters,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
    });
  };

  function onCloseModalvalues() {
    setModalOpen(false);
    setDescModalOpen(false);
  }

  const status = [
    {
      label: "All",
      value: "",
    },
    {
      label: "open",
      value: "open",
    },
    {
      label: "close",
      value: "close",
    },
  ];

  const locations = [
    {
      label: "noida",
      value: "noida",
    },
    {
      label: "delhi",
      value: "delhi",
    },
    {
      label: "ghaziabaad",
      value: "ghaziabaad",
    },
    {
      label: "bangalore",
      value: "bangalore",
    },
  ];

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: deleteCareer,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getCareerData();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const payload = {
    filters: filters,
    token: userInfoData?.token,
  };

  const getCareerData = () => {
    dispatch(fetchCareerData(payload));
  };

  useEffect(() => {
    getCareerData();
  }, [filters]);

  useEffect(() => {
    if (searchValue.length === 0) {
      setFilters({
        ...filters,
        search: "",
      });
    }
  }, [searchValue]);

  const handleEdit = (row) => {
    setIsEdit(true);
    setModalOpen(true);
    setInitialValue(row);
  };

  const handleAdd = () => {
    setIsEdit(false);
    setModalOpen(true);
    setInitialValue(null);
  };

  const handleDescription = (desc) => {
    setModValues(desc);
    setDescModalOpen(true);
  };

  const tbColumns = [
    {
      dataField: "job_title",
      text: "Job Title",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.job_title || "NA"}</span>
        );
      },
    },
    {
      dataField: "posting_date",
      text: "Posting Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {moment(row?.posting_date).tz("Asia/Kolkata").format("DD-MM-YYYY")}
          </span>
        );
      },
    },
    {
      dataField: "location",
      text: "location",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.location || "NA"}</span>
        );
      },
    },
    {
      dataField: "job_description",
      text: "job description",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.job_description?.length <= 40 ? (
              <span
                dangerouslySetInnerHTML={{ __html: row?.job_description }}
              />
            ) : row?.job_description?.length >= 40 ? (
              <>
                <span
                  dangerouslySetInnerHTML={{
                    __html: row?.job_description?.substring(0, 40),
                  }}
                />
                <b
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDescription(row.job_description)}>
                  ...Read More
                </b>
              </>
            ) : (
              "NA"
            )}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <div className="tb-data minWidth100 career__Desc">
            <span>{row?.status || "NA"}</span>
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => handleEdit(row)}>
            <EditIcon />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}>
            {loading ? <Loader /> : <DeleteIcon />}
          </button>
        </div>
      ),
    },
  ];

  const onClickSearch = () => {
    setFilters({
      ...filters,
      search: searchValue,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setFilters({
      ...filters,
      start_date: "",
      end_date: "",
    });
  };

  return (
    <HelmetWrapper title="WTF: Career AT WTF">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"Career At WTF"} />
          </Col>
        </Row>
        <br />
        <div className="spaceBetChild secChild career__AddButton">
          <button type="button" className="btn btn-danger" onClick={handleAdd}>
            Add New
          </button>
        </div>
        <br />

        <div className="career__Grid">
          <div
            className={`inputCommonWrapper flexSpacebetween searchBarContainer `}>
            <input
              type="search"
              className="input"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <button type="button" className="button" onClick={onClickSearch}>
              search
              <SearchIcon />
            </button>
          </div>

          <div className="formInputBox form__Select commonWrapper dropdownCommonWrapper">
            <SelectDropdownLabel
              options={locations}
              selectedOption={filters.search?.label}
              setSelectedOption={(selectedValue) => {
                setFilters({
                  ...filters,
                  search: selectedValue?.value || "",
                });
              }}
              name="select location"
            />
          </div>

          <div className="filtersDropdown">
            <div
              className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper ${
                filters?.start_date || filters?.end_date
                  ? "redBorderRedText"
                  : ""
              }`}>
              {openDateRanger ? (
                <div className="closeAndClearDateRangerButtons">
                  <button
                    className="closeClearBtn notmalButtonStyles noStyle closeRangerBtn"
                    onClick={() => setOpenDateRanger(false)}
                    style={{ textAlign: "center" }}>
                    <CloseIcon />
                    Close
                  </button>
                  <button
                    className="closeClearBtn notmalButtonStyles noStyle clearRangerBtn"
                    onClick={clearDateRanger}
                    // onClick={!isLoading && clearDateRanger}
                    style={{ textAlign: "center" }}
                    // disabled={isLoading}
                  >
                    <ClearIcon />
                    Clear
                  </button>
                </div>
              ) : filters?.start_date || filters?.end_date ? (
                <div className="flex-between">
                  <button
                    type="button"
                    className="notmalButtonStyles noStyle long_one"
                    // onClick={() => !isLoading && setOpenDateRanger(true)}
                    onClick={() => setOpenDateRanger(true)}
                    style={{ fontSize: "13px" }}
                    // disabled={isLoading}
                  >
                    <span className="dates">
                      {moment(filters?.start_date)
                        .tz("Asia/Kolkata")
                        .format("DD-MM-YYYY")}
                    </span>
                    <small>TO</small>
                    <span className="dates">
                      {moment(filters?.end_date)
                        .tz("Asia/Kolkata")
                        .format("DD-MM-YYYY")}
                    </span>
                  </button>

                  <button
                    type="button"
                    className="notmalButtonStyles noStyle short_one"
                    // onClick={!isLoading && clearDateRanger}
                    onClick={clearDateRanger}
                    // disabled={isLoading}
                  >
                    <ClearCalenderIcon />
                  </button>
                </div>
              ) : (
                <button
                  type="button"
                  className="notmalButtonStyles noStyle"
                  // onClick={() => !isLoading && setOpenDateRanger(true)}
                  onClick={() => setOpenDateRanger(true)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                  // disabled={isLoading}
                >
                  Select Date Added
                  <CalenderIcon />
                </button>
              )}
            </div>
          </div>

          {openDateRanger && (
            <div className="openedDateRanger dateCommonWrapper">
              <DateRanger
                handleDateRangeChange={handleDateRangeChange}
                rangeState={rangeState}
                onClose={() => setOpenDateRanger(false)}
                onClear={clearDateRanger}
              />
            </div>
          )}
          <div className="formInputBox form__Select commonWrapper dropdownCommonWrapper">
            <SelectDropdownLabel
              options={status}
              className="input"
              selectedOption={filters.status?.label}
              setSelectedOption={(selectedValue) => {
                setFilters({
                  ...filters,
                  status: selectedValue?.value || "",
                });
              }}
              name="Select Status"
            />
          </div>
        </div>

        <div>
          <Modal
            isOpen={modalOpen}
            onRequestClose={onCloseModalvalues}
            contentLabel="Career Modal"
            ariaHideApp={false}>
            <CareerForm
              getCareerData={getCareerData}
              isEdit={isEdit}
              closeModal={onCloseModalvalues}
              initialValues={initialValue}
              token={userInfoData?.token}
            />
          </Modal>
          <Modal
            isOpen={descModalOpen}
            onRequestClose={onCloseModalvalues}
            contentLabel="Text Modal"
            ariaHideApp={false}>
            <div className="discussionModalMessage mt30 createNewCTOModalContainer mod-width-50p careerFormModal">
              <ModalHeadAndClose
                title="Job Description"
                onClose={onCloseModalvalues}
              />
              <br />
              <p
                className="message"
                dangerouslySetInnerHTML={{ __html: modValues }}
              />
            </div>{" "}
          </Modal>

          <div className="fullWidthFlexCenter overflowAuto separatedTable">
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={careerData?.data?.length > 0 ? careerData?.data : []}
                tableColumns={tbColumns}
                tablePagination={
                  careerData?.pagination?.length > 0
                    ? careerData?.pagination
                    : []
                }
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
              />
            )}
          </div>
        </div>
      </Container>
    </HelmetWrapper>
  );
};

export default Career;
